import CustomModal from 'components/global/CustomModal'
import React from 'react'
import { creationEventStore } from 'state/event/eventCreationStore'
import { Col, DatePicker, Form, FormInstance, Row } from 'antd'
import moment from 'moment'
import { startOfLocalDayInUTC } from 'helper/utility'
import useFormSubmit from 'helper/Hooks/formSubmit'
import CustomModalFooter from 'components/global/CustomModalFooter'
import { useDuplicateEvent } from 'api/EventCreation/OrganizationEvents'
import { myStore } from 'state/store'

const DuplicateModal: React.FC = () => {
  const { form, handleSubmit } = useFormSubmit()
  const { mutate: duplicateEventMutation } = useDuplicateEvent()
  const { duplicateModalOpen, setDuplicateModalOpen, setEventData, eventData } =
    creationEventStore(store => ({
      duplicateModalOpen: store.duplicateModalOpen,
      setDuplicateModalOpen: store.setDuplicateModalOpen,
      setEventData: store.setEventData,
      eventData: store.eventData,
    }))
  const setModalBtnLoader = myStore(state => state.setModalBtnLoader)
  const closeMdoal = () => {
    setEventData(null)
    setDuplicateModalOpen(false)
  }

  const onFinish = (values: any) => {
    setModalBtnLoader(true)
    const payload = {
      newStartDate: startOfLocalDayInUTC(values.startDate),
      eventId: eventData.id,
    }
    duplicateEventMutation(payload, {
      onSuccess: () => {
        setModalBtnLoader(false)
        closeMdoal()
      },
      onError: () => {
        setModalBtnLoader(false)
      },
    })
  }

  return (
    <>
      <CustomModal
        openModal={duplicateModalOpen}
        isCloseModalCustom={true}
        closeModal={closeMdoal}
        title="Duplicate Event"
        width={600}
        footer={
          <CustomModalFooter
            multibutton={true}
            btnAlignment="justify-between"
            btnText="Cancel, Duplicate"
            closeModal={closeMdoal}
            onSubmit={handleSubmit}
          />
        }
      >
        <Form form={form} onFinish={onFinish}>
          <Row>
            <Col span={24}>
              <label htmlFor="" className="input-label required-input">
                Select start date
              </label>
              <Form.Item
                name="startDate"
                required
                rules={[{ required: true, message: 'Date is required' }]}
              >
                <DatePicker name="startDate" className="selector w-full" />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </CustomModal>
    </>
  )
}

export default DuplicateModal
